import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PageLayout from '../components/PageLayout';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from 'react-router-dom';

export default function TermsOfUse() {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/');
    };

    return (
        <PageLayout
            breadcrumb={[
                { label: 'Home', to: '/' },
                { label: 'Terms of Use' }
            ]}
            showBack={false}
            showClose={true}
            onClose={handleClose}
            icon={<DescriptionIcon fontSize="large" />}
            title="Terms of Use"
            subTitle="Please read carefully"
        >
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Typography variant="body1" paragraph>
                    Welcome to Grind Analytics LLC (&quot;Grind Analytics&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). By accessing or using this website (the &quot;Site&quot;), you agree to be bound by these Terms of Use (&quot;Terms&quot;) and our Privacy Policy. If you do not agree to these Terms, please do not use the Site.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>1. Use of the Site:</strong> The Site is provided for your personal, non-commercial use. You may not modify, reproduce, distribute, or create derivative works from any content found on this Site without our prior written permission.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>2. Account Responsibility:</strong> If you register for an account, you are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to immediately notify us of any unauthorized use of your account.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>3. Intellectual Property:</strong> All content, trademarks, and data on this Site, including but not limited to text, graphics, logos, icons, and software, are the property of Grind Analytics LLC or its licensors. Unauthorized use of any materials is strictly prohibited.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>4. Disclaimer of Warranties:</strong> The Site is provided &quot;as is&quot; and without warranties of any kind, whether express or implied. Grind Analytics LLC disclaims all warranties, including without limitation any implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>5. Limitation of Liability:</strong> In no event shall Grind Analytics LLC be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the Site.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>6. Changes to Terms:</strong> We reserve the right to update or modify these Terms at any time. Any changes will be effective immediately upon posting on the Site. Your continued use of the Site after such changes constitutes your acceptance of the new Terms.
                </Typography>
                <Typography variant="body1" paragraph>
                    <strong>7. Governing Law:</strong> These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Grind Analytics LLC is established, without regard to its conflict of law provisions.
                </Typography>
                <Box sx={{ mt: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                        Last updated: March 21, 2025
                    </Typography>
                </Box>
            </Container>
        </PageLayout>
    );
}
